<template>
  <div class="date-range" :class="{'date-range--view-only': isActivated}">
    <span class="date-range__label">From</span>
    <span class="date-range__value"
          @click="createStartPopover">{{ startDateName }} <svg-icon :icon="arrow" :width="12" :height="8"></svg-icon></span>
    <span class="date-range__label">To</span>
    <span class="date-range__value"
          @click="createEndPopover">{{ endDateName }} <svg-icon :icon="arrow" :width="12" :height="8"></svg-icon></span>
  </div>
</template>

<script>
  import {
    UPDATE_START_DATE,
    UPDATE_END_DATE
  } from './store/actions'
  import { createPopover, popoverTypes } from '@/components/common/popover'
  import SvgIcon from '@/components/common/svgIcon'
  import arrow from '@/assets/svg/arrow.svg'

  export default {
    components: {
      SvgIcon
    },
    data () {
      return {
        arrow,
        popover: null
      }
    },
    computed: {
      isActivated () {
        return this.$store.getters.isTargetActivated
      },
      startDate () {
        return this.$store.getters.dateRange.startDate
      },
      startDateName () {
        return this.startDate ? this.startDate.name : '----'
      },
      endDate () {
        return this.$store.getters.dateRange.endDate
      },
      endDateName () {
        return this.endDate ? this.endDate.name : '----'
      },
      availableDates () {
        return this.$store.getters.dateRange.availableDates
      },
      popoverStartList () {
        return this.availableDates
          .slice(0, this.availableDates.indexOf(this.endDate) + 1)
          .map(date => {
            return {
              name: date.name,
              value: date.from
            }
          })
      },
      popoverEndList () {
        return this.availableDates
          .slice(this.availableDates.indexOf(this.startDate), this.availableDates.length)
          .map(date => {
            return {
              name: date.name,
              value: date.to
            }
          })
          .reverse()
      }
    },
    methods: {
      createStartPopover (e) {
        if (this.isActivated) return
        this.popover = createPopover({
          direction: 'bottom',
          list: this.popoverStartList,
          parent: e.currentTarget,
          root: document.getElementById('app'),
          type: popoverTypes.TEXTLIST
        })
        this.popover
          .$on('select', selected => {
            this.$store.dispatch(UPDATE_START_DATE, selected)
          })
      },
      createEndPopover (e) {
        if (this.isActivated) return
        this.popover = createPopover({
          direction: 'bottom',
          list: this.popoverEndList,
          parent: e.currentTarget,
          root: document.getElementById('app'),
          type: popoverTypes.TEXTLIST
        })
        this.popover
          .$on('select', selected => {
            this.$store.dispatch(UPDATE_END_DATE, selected)
          })
      }
    }
  }
</script>

<style lang="scss">
  .date-range {
    display: flex;
    align-items: baseline;

    &__label {
      text-transform: uppercase;
      font-size: rem(10);
      padding: 0 rem(8);
    }

    &__value {
      flex-shrink: 0;
      font-weight: bold;
      font-size: rem(14);
      border-bottom: rem(1) solid color(grays, light);
      cursor: pointer;
      padding: 0 rem(6) 0 rem(8);
    }

    &__value + &__label {
      border-left: rem(1) solid color(grays, light);
      margin-left: rem(8);
    }

    svg {
      fill: color(blues, normal);
      transform: rotate(90deg);
      width: rem(12) !important;
      height: rem(12) !important;
    }

    &--view-only {
      svg {
        display: none;
      }

      .date-range__value {
        cursor: default;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DateRange.vue?35469df0